export const SEND_CHANNEL_INVITE = 'send-channel-invite';
export const INVITE_NOTIFICATION = 'invite-notification';
export const INVITE_ACCEPTED = 'accepted-channel-invite';
export const INVITE_ACCEPT = 'handle-channel-invite';
